module.exports = __webpack_public_path__ + "img/facebook-icon.c9d99ccc.svg";